/* global window */
export var DEFAULT_VISIBILITY_THRESHOLD = 0.6;
export var DEFAULT_SCROLL_OFFSET = -24;
export var DEFAULT_SCROLL_BEHAVIOR = "smooth";

function getWindowScrollTop() {
  if (typeof window === "undefined") return 0;
  if (window.scrollY == null) return window.pageYOffset;
  return window.scrollY;
}

function getWindowScrollLeft() {
  if (typeof window === "undefined") return 0;
  if (window.scrollX == null) return window.pageXOffset;
  return window.scrollX;
}
/**
 * This will use the native `window.scroll` method to scroll to a particular location using
 * animation if possible.
 */


export function scrollTo(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$top = _ref.top,
      top = _ref$top === void 0 ? getWindowScrollTop() : _ref$top,
      _ref$left = _ref.left,
      left = _ref$left === void 0 ? getWindowScrollLeft() : _ref$left,
      _ref$behavior = _ref.behavior,
      behavior = _ref$behavior === void 0 ? DEFAULT_SCROLL_BEHAVIOR : _ref$behavior;

  if (typeof window === "undefined") return;

  try {
    // Use options object, if supported, to get a smooth scroll
    window.scroll({
      left: left,
      top: top,
      behavior: behavior
    });
  } catch (error) {
    // otherwise fallback to setting the scroll position
    window.scroll(left, top);
  }
}
export function isElementVisible(element, visibilityThreshold) {
  if (visibilityThreshold === void 0) {
    visibilityThreshold = 0.667;
  }

  if (typeof window === "undefined" || element == null) return false;

  var _element$getBoundingC = element.getBoundingClientRect(),
      top = _element$getBoundingC.top;

  return top > 0 && top < window.innerHeight * visibilityThreshold;
}
export function scrollToElement(element, _temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
      always = _ref2.always,
      _ref2$visibilityThres = _ref2.visibilityThreshold,
      visibilityThreshold = _ref2$visibilityThres === void 0 ? DEFAULT_VISIBILITY_THRESHOLD : _ref2$visibilityThres,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? DEFAULT_SCROLL_OFFSET : _ref2$offset,
      _ref2$behavior = _ref2.behavior,
      behavior = _ref2$behavior === void 0 ? DEFAULT_SCROLL_BEHAVIOR : _ref2$behavior;

  if (always || !isElementVisible(element, visibilityThreshold)) {
    var elementTop = element.getBoundingClientRect().top + getWindowScrollTop();
    scrollTo({
      top: elementTop + offset,
      behavior: behavior
    });
  }
}